module.exports = __webpack_public_path__ + "static/media/instagram.d512fc9c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/megabus/instagram.svg
// module id = 247
// module chunks = 0